import type { OpportunityStatus, OpportunityUpdateInput } from "../types";

export interface ValidationErrors {
  nextCheckInOn?: string;
  reason?: string;
  reviewOn?: string;
  files?: string;
}

export function isTerminalStatus(status: OpportunityStatus): boolean {
  return status === "Completed" || status === "Closed - not proceeding";
}

export function validateOpportunityUpdate(
  input: OpportunityUpdateInput,
): ValidationErrors {
  const errors: ValidationErrors = {};
  if (!isTerminalStatus(input.status) && !input.nextCheckInOn)
    errors.nextCheckInOn = "required";
  if (
    (input.status === "On hold" ||
      input.status === "Closed - not proceeding") &&
    !input.reason?.trim()
  )
    errors.reason = "required";
  if (input.status === "On hold" && !input.reviewOn)
    errors.reviewOn = "required";
  if ((input.files?.length ?? 0) > 5) errors.files = "tooMany";
  if (input.files?.some((file) => file.size > 10 * 1024 * 1024))
    errors.files = "tooLarge";
  return errors;
}
